import React from "react";
import { Loader2 } from "lucide-react";

const FieldEditModal = ({ field, value, onChange, onSave, onCancel, saving, displayName }) => {
  const ftype = (field?.field_type || "text").toLowerCase();
  const options = Array.isArray(field?.options) ? field.options : [];

  const renderInput = () => {
    if (ftype === "checkbox") {
      const boolVal =
        value === true || value === "true"
          ? true
          : value === false || value === "false"
          ? false
          : null;
      return (
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => onChange(true)}
            className={`px-3 py-1.5 rounded-md text-[13px] font-medium border transition-colors ${
              boolVal === true
                ? "bg-[#C95EBE] text-white border-[#C95EBE]"
                : "bg-white text-[#52525B] border-gray-200 hover:bg-gray-50"
            }`}
          >
            Checked
          </button>
          <button
            type="button"
            onClick={() => onChange(false)}
            className={`px-3 py-1.5 rounded-md text-[13px] font-medium border transition-colors ${
              boolVal === false
                ? "bg-[#C95EBE] text-white border-[#C95EBE]"
                : "bg-white text-[#52525B] border-gray-200 hover:bg-gray-50"
            }`}
          >
            Unchecked
          </button>
          <button
            type="button"
            onClick={() => onChange("")}
            className={`px-3 py-1.5 rounded-md text-[13px] font-medium border transition-colors ${
              boolVal === null
                ? "bg-gray-200 text-[#18101C] border-gray-300"
                : "bg-white text-[#52525B] border-gray-200 hover:bg-gray-50"
            }`}
          >
            Clear
          </button>
        </div>
      );
    }

    if ((ftype === "dropdown" || ftype === "radio") && options.length > 0) {
      return (
        <select
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-200 rounded-md text-[14px] focus:outline-none focus:border-[#C95EBE]"
        >
          <option value="">— Clear —</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      );
    }

    if (ftype === "date") {
      return (
        <input
          type="text"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="YYYY-MM-DD"
          className="w-full px-3 py-2 border border-gray-200 rounded-md text-[14px] focus:outline-none focus:border-[#C95EBE]"
        />
      );
    }

    return (
      <textarea
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
        className="w-full px-3 py-2 border border-gray-200 rounded-md text-[14px] resize-y focus:outline-none focus:border-[#C95EBE]"
      />
    );
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-[1px]"
      onClick={() => {
        if (!saving) onCancel();
      }}
    >
      <div
        className="bg-white rounded-xl shadow-2xl w-full max-w-[520px] font-outfit border border-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 pt-5 pb-3 border-b border-gray-100">
          <p className="text-[12px] uppercase tracking-wide text-[#71717A] font-medium">
            {field?.section || "Edit field"}
          </p>
          <h2 className="text-[16px] font-semibold text-[#18101C] mt-1">
            {field?.label?.trim() || displayName || "Field"}
          </h2>
          <p className="text-[12px] text-[#52525B] mt-1">
            Type: <span className="font-medium">{ftype}</span>
            {field?.user_overridden ? " · previously edited" : ""}
          </p>
        </div>

        <div className="px-6 py-5">
          <label className="block text-[13px] font-medium text-[#52525B] mb-2">
            Answer
          </label>
          {renderInput()}
          {ftype === "text" || ftype === "signature" || ftype === "date" ? (
            <p className="text-[11px] text-[#71717A] mt-2">
              Leave empty and Save to clear this field.
            </p>
          ) : null}
        </div>

        <div className="px-6 pb-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={saving}
            className="px-4 py-2 rounded-md text-[14px] font-medium text-[#52525B] hover:bg-gray-100 disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            disabled={saving}
            className="flex items-center gap-2 px-4 py-2 rounded-md text-[14px] font-medium bg-[#C95EBE] text-white hover:bg-[#b04da6] disabled:opacity-60"
          >
            {saving ? (
              <>
                <Loader2 size={14} className="animate-spin" />
                Saving...
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FieldEditModal;
